import { colors } from '@sweep-io/sweep-design';
import kebabCase from 'lodash/kebabCase';

/**
 * Base style for all mark elements (search highlights)
 * Note: Using outline instead of border to prevent clipping in table cells
 * Outline doesn't take up space and isn't clipped by parent overflow
 */
const baseMarkStyle = {
  borderRadius: '2px',
  outline: `1px solid ${colors.spark}`,
  outlineOffset: '0px',
} as const;

/**
 * Style for the current active match (highlighted in blue)
 */
export const currentMatchMarkStyle = {
  ...baseMarkStyle,
  backgroundColor: colors.spark,
} as const;

/**
 * Style for regular matches (highlighted in yellow)
 */
export const regularMatchMarkStyle = {
  ...baseMarkStyle,
  backgroundColor: colors.lemon[100],
} as const;

/**
 * Converts a style object to a CSS string for use in inline styles
 */
export const styleObjectToString = (styleObj: Record<string, string>): string => {
  return Object.entries(styleObj)
    .map(([key, value]) => {
      // Convert camelCase to kebab-case
      const kebabKey = kebabCase(key).toLowerCase();
      return `${kebabKey}: ${value}`;
    })
    .join('; ');
};

/**
 * Creates a mark HTML string with the given style and content
 */
export const createMarkTag = (content: string, isCurrent: boolean): string => {
  const style = isCurrent ? currentMatchMarkStyle : regularMatchMarkStyle;
  const styleString = styleObjectToString(style);
  const className = isCurrent ? 'search-highlight-current' : 'search-highlight';
  return `<mark class="${className}" style="${styleString}">${content}</mark>`;
};
